(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.bsb-hp').forEach(initSection);
  }

  function initSection(section) {
    if (section.dataset.bsbHpInitialized) return;
    section.dataset.bsbHpInitialized = 'true';

    const pills = Array.from(section.querySelectorAll('.bsb-hp__pill'));
    if (!pills.length) return;

    function findSection(id) {
      return (
        document.querySelector(`[id$="__${id}"]`) ||
        document.getElementById(`shopify-section-${id}`) ||
        document.getElementById(id)
      );
    }

    function setActive(pill) {
      pills.forEach((p) => {
        const active = p === pill;
        p.classList.toggle('bsb-hp__pill--active', active);
        p.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const hideIds = (pill.dataset.hide || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);

      const allIds = pills
        .flatMap((p) =>
          (p.dataset.hide || '').split(',').map((s) => s.trim()).filter(Boolean)
        )
        .filter((id, i, arr) => arr.indexOf(id) === i);

      allIds.forEach((id) => {
        const el = findSection(id);
        if (!el) return;
        el.style.display = hideIds.includes(id) ? 'none' : '';
      });
    }

    pills.forEach((pill) => {
      pill.addEventListener('click', () => setActive(pill));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
